import * as React from 'react';
import { StyledNorth, StyledSouth, StyledEast, StyledWest } from './CardinalDirectionIndicator.styled';

export const CardinalDirectionIndicator: React.FunctionComponent = () => {
  return (
    <>
      <StyledNorth>N</StyledNorth>
      <StyledSouth>S</StyledSouth>
      <StyledEast>E</StyledEast>
      <StyledWest>W</StyledWest>
    </>
  );
};
